/**
 * 모듈 조회 훅 (TanStack Query)
 *
 * - GET /modules   13모듈 + 회사 프로비저닝 상태
 *
 * 동적 메타모델: 13모듈은 프로비저닝 축일 뿐 모듈별 하드코딩 분기 금지.
 * 표시 라벨은 nameI18n + resolveLabel 로 해석.
 */
import { useQuery } from "@tanstack/react-query";
import type { I18nLabel, Module } from "@eqms/shared-types";

import { apiFetch } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

/** GET /modules 응답 항목 (회사 프로비저닝 상태 + 다국어 라벨 포함) */
export interface ModuleResponse extends Module {
  /** 다국어 라벨 맵 (`{ko,en,zh,ja}`) */
  nameI18n?: I18nLabel;
  /** 회사 프로비저닝 활성 여부 */
  enabled?: boolean;
  /** 정렬 순서 (서버 제공 시) */
  sort?: number;
}

/** 13모듈 + 회사 프로비저닝 상태 */
export function useModules() {
  return useQuery({
    queryKey: queryKeys.modules.all(),
    queryFn: () => apiFetch<ModuleResponse[]>("/api/modules"),
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}
